export const formatPlanPriceDisplay = (priceAmount: number, priceCurrency: string): string => {
  if (priceAmount <= 0) {
    return 'Free';
  }
  const normalizedCurrency = priceCurrency.trim().toUpperCase();
  const majorUnits = (priceAmount / 100).toFixed(2);
  return `${normalizedCurrency} ${majorUnits}`;
};

export const formatCreditsInteger = (value?: number): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '0';
  }

  return Math.round(value).toLocaleString();
};

export const formatCreditsCompact = (value?: number): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '0';
  }

  const roundedValue = Math.round(value);

  if (roundedValue >= 1_000_000) {
    return `${(roundedValue / 1_000_000).toFixed(1).replace(/\.0$/, '')}m`;
  }

  if (roundedValue >= 1_000) {
    return `${(roundedValue / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
  }

  return roundedValue.toLocaleString();
};
